import { connect } from 'react-redux';
import { deletePortaluserPesan } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deletePortaluserPesan,
};

function ModalDeletePesanItem({ data, deletePortaluserPesan, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deletePortaluserPesan({ auth, history, values: item });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='my-5 mx-5'>
        Apakah Anda yakin ingin menghapus pesan{' '}
        <span className='has-text-danger has-text-weight-semibold'>{`${item.title}`}</span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center pt-2 px-5'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}


export default connect(null, actions)(ModalDeletePesanItem);
